import React from "react";
import PropTypes from "prop-types";

import Header from "components/Library/Header";

import styles from "./SearchStreamHeader.css";

export default function SearchStreamHeader({ searchTerm }) {
  return (
    <Header
      className={styles.clipboard}
      text={`“${searchTerm}”`}
      subText="Search Results"
    />
  );
}

SearchStreamHeader.propTypes = {
  searchTerm: PropTypes.string.isRequired,
};
